import { createPageObjects } from './page-objects';
import { createAppPageObject } from './page-objects/app';

export type { EnhancedPage } from './page-objects/app';
export { createPageObjects, createAppPageObject };
